import EventBus from "eventing-bus"
import { constants, getCurrSection, zoomBoardView } from "../model"
import gsap from "gsap"

const viewEl = document.querySelector("#zoom-ui-view"),
  imgEl = viewEl.querySelector("img"),
  swipeRotate = viewEl.querySelector(".swipe-rotate"),
  closeEl = viewEl.querySelector(".close-btn")

const handleSectionChanged = () => {
  if (getCurrSection() === 3) {
    setTimeout(() => {
      viewEl.classList.add("show")
      imgEl.addEventListener("click", handleZoomBtnClicked)
      closeEl.addEventListener("click", handleCloseBtnClicked)
    }, 5300)
  } else {
    viewEl.classList.remove("show")
  }
}

const handlePlayZoom = (bool) => {
  if (bool) showZoomed()
  else showRegular()
}

const handleZoomBtnClicked = () => {
  zoomBoardView(true)
  showZoomed()
}

const handleCloseBtnClicked = () => {
  zoomBoardView(false)
  showRegular()
}

const showZoomed = () => {
  imgEl.classList.remove("show")
  closeEl.classList.add("show")
  swipeRotate.classList.add("show")
  animateSwipeToRotate()
}

const showRegular = () => {
  imgEl.classList.add("show")
  closeEl.classList.remove("show")
  swipeRotate.classList.remove("show")
}

EventBus.on(constants.SECTION_CHANGED, handleSectionChanged)
EventBus.on(constants.PLAY_PRODUCT_ZOOM, handlePlayZoom)

const animateSwipeToRotate = () => {
  gsap.fromTo(swipeRotate, { alpha: 0, y: 50 }, { duration: 1.5, alpha: 1, y: 0, delay: 2, ease: "circ.out" })
  gsap.to(swipeRotate, { duration: 1, alpha: 0, y: -40, delay: 4, ease: "power3.in" })
}
